<style lang="scss" scoped>
.padding {
	padding: 20px 40px;
}
</style>
<template>
	<div>
		<app-header>
			<template slot="header">
				<div class="d-flex">
					<h1>
						<i class="fe fe-smartphone" style="margin-right:15px"></i> Student credentials sender log
					</h1>
					<div class="ml-auto custom-width">
						<el-button @click="$router.push({name:`communication`})">Back to parent communication</el-button>
					</div>
				</div>
			</template>
		</app-header>
		<div class="container">
			<div class="main-panel directory">
				<div class="padding">
					<p>This page provides you with a log of all the text messages and emails sent to student's parents.</p>
				</div>
				<el-table class="custom-table" :data="CommunicationLog">
					<el-table-column prop="id" label="id"></el-table-column>
					<el-table-column prop="forename" label="Forename"></el-table-column>
					<el-table-column prop="surname" label="Surname"></el-table-column>
					<el-table-column prop="method" label="Method"></el-table-column>
					<el-table-column prop="target" width="400" label="Target"></el-table-column>
					<el-table-column prop="created_at" width="250" label="Sent at">
						<template slot-scope="scope">{{ moment(scope.row.created_at*1).format('LLL')}}</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";

export default {
	data() {
		return {
			moment
		};
	},

	apollo: {
		CommunicationLog: {
			query: gql`
				{
					CommunicationLog {
						id
						forename
						surname
						method
						target
						created_at
					}
				}
			`
		}
	}
};
</script>